import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";
import {PropTypes} from "prop-types";

import Loading from "../../../components/etc/loading";

import * as Actions from "../../../store/modules/departments";
import * as func from "../../../utils/functions";
import * as hooks from "../../../utils/hooks";
import CollegeItem from "../../../components/department/front/list/collegeItem";
import SubCollege from "../../../components/department/front/list/subCollege";

class Departments extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isInit: false,
			action : 'departments'
		}
	}

	componentDidMount() {
		hooks.menuHook(this, this.state.action);
		this.getList();
	}

	componentWillUnmount(){
		this.setState = (state, callback) => {
			return;
		}
	}

	getList() {
		func.getData(this.state.action, this.props.param).then((response) => {
			this.setState({
				isInit: true,
			})

			this.props.dataActions.setDepartments(response);
		});
	}

	render() {
		const {records} = this.props;
		const {isInit} = this.state;

		return (
			<div className="contents-group">
				{!isInit && <div className="m-auto m-0"><Loading/></div>}
				{isInit &&
				<div className="center-group">
					<div className="mt-px-40">
						<div className="department-tab-nav">
							<div className="department-tab-inner">
								{records.map((record, index) => {
									if(record.category_id)
										return ( <CollegeItem key={index} record={record}/> )
								})}
							</div>
						</div>
					</div>
					<div className="mt-2">
						{records.map((record, index) => {
							if(record.category_id)
								return (
									<SubCollege key={index}
								            ref={(ref) => this[record.category_code] = ref}
								            record={record}/>
							)
						})}
					</div>
				</div>
				}
			</div>
		)
	}
}

export default connect(
	(state) => ({
		param: state.departments.param ? state.departments.param : {},
		records: state.departments.records ? state.departments.records : [],
	}),
	(dispatch) => ({
		dataActions: bindActionCreators(Actions, dispatch)
	}),
)(Departments)

// Departments.propTypes = {
//     param : PropTypes.object,
//     records : PropTypes.array,
//     facet : PropTypes.object,
//     totalRecords : PropTypes.number,
//     totalPage : PropTypes.number,
// };
